import Rest from "@/services/Rest";

export default class SourceService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/sources'

}
